// extracted by mini-css-extract-plugin
export default {"message_list":"DialogContent_message_list__XhFtm","compose":"DialogContent_compose__ybn8D"};